import { render } from "./AwayStatusModal.vue?vue&type=template&id=f6c2523e"
import script from "./AwayStatusModal.vue?vue&type=script&lang=js"
export * from "./AwayStatusModal.vue?vue&type=script&lang=js"

import "./AwayStatusModal.vue?vue&type=style&index=0&id=f6c2523e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__